"use client";
import { ThemeProvider } from "next-themes";
import { AuthUserContext } from "./authUserContext";
import { useState } from "react";

export default function Providers({ children }: { children: React.ReactNode }) {
  const [authUser, setAuthUser] = useState({});
  return (
    <>
      <ThemeProvider enableSystem={true} attribute="class">
        <AuthUserContext.Provider value={{ authUser, setAuthUser }}>
          {children}
        </AuthUserContext.Provider>
      </ThemeProvider>
    </>
  );
}
